export enum FiCustomValidatorPatterns {
    Email = '^\\w+([\\.\\-]?\\w+)*@\\w+([\\.\\-]?\\w+)*(\\.\\w{2,})+$',
    CVVCode = '^[0-9]{3}$',
    CreditCard = '^[0-9]{4}\\s?[0-9]{4}\\s?[0-9]{4}\\s?[0-9]{4}$',
    VATNumber = '^[a-zA-Z0-9]{2,12}$',
    StringWithoutSpaces = '[^\\s]+',
    PhoneNumber = '^\\+[0-9]+$', // starts with + then only numbers
    PhoneNumberWithoutCountryCode = '^[0-9]+$',
    LeadingZeroNumber = '^0*\\d+(\\.\\d+)?$',
}
